import { render, staticRenderFns } from "./BannerHoldAudit.vue?vue&type=template&id=c91964fc"
import script from "./BannerHoldAudit.vue?vue&type=script&lang=js"
export * from "./BannerHoldAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports